import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { selectAtom } from 'jotai/utils';

export interface Payload {
  onCreateFolder?: (folderName: string) => Promise<any>;
  onChangeFolder?: (folderId: string) => Promise<any>;
  onChangeSequence?: (folderId: string) => Promise<any>;
  title: string;
}

const payloadAtom = atom<Payload | undefined>(undefined);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
export const useIsOpenAllFoldersWithOrWithoutSequencesModal = () =>
  useAtomValue(isOpenAtom);

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, undefined));
export const useCloseAllFoldersWithOrWithoutSequencesModal = () =>
  useSetAtom(closeModalAtom);

export const useOpenAllFoldersWithOrWithoutSequencesModal = () =>
  useSetAtom(payloadAtom);

export const useGetAllFoldersWithOrWithoutSequencesModalPayload = () =>
  useAtomValue(payloadAtom);
